module.exports = __webpack_public_path__ + "img/analysis.6ae2f6b.svg";